import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import appMockup from '../assets/app-mockup.png';

const AppShowcase = () => {
    const { scrollYProgress } = useScroll();
    const y = useTransform(scrollYProgress, [0.5, 1], [0, -50]);
    const scale = useTransform(scrollYProgress, [0.5, 0.8], [0.9, 1]); // Subtle zoom in

    return (
        <section style={{
            padding: '10rem 2rem',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(180deg, var(--bg-dark) 0%, #0A140C 100%)'
        }}>
            {/* Mesh Gradient Background */}
            <div style={{
                position: 'absolute',
                top: '20%',
                right: '-10%',
                width: '60vw',
                height: '60vw',
                background: 'radial-gradient(circle, rgba(26, 77, 46, 0.2) 0%, rgba(0,0,0,0) 70%)',
                filter: 'blur(80px)',
                opacity: 0.6,
                zIndex: 0
            }} />

            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                position: 'relative',
                zIndex: 1
            }}>
                <div style={{ flex: 1, minWidth: '350px', marginBottom: '4rem', paddingRight: '4rem' }}>
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        style={{
                            color: 'var(--accent)',
                            fontWeight: '600',
                            letterSpacing: '0.1em',
                            marginBottom: '1rem',
                            display: 'block'
                        }}
                    >
                        APP ECOSYSTEM
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        style={{
                            fontSize: '3.5rem',
                            marginBottom: '2rem',
                            lineHeight: 1.1,
                            fontFamily: 'Playfair Display, serif'
                        }}
                    >
                        Your garden,<br />
                        <span style={{
                            background: 'linear-gradient(90deg, #fff, #999)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>decrypted.</span>
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        style={{
                            fontSize: '1.2rem',
                            color: 'var(--text-muted)',
                            marginBottom: '3rem',
                            maxWidth: '450px',
                            lineHeight: 1.8
                        }}
                    >
                        Access real-time telemetry, get instant alerts, and track the health history of every plant in your collection through our minimalistic dashboard.
                    </motion.p>

                    <motion.ul
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        style={{ listStyle: 'none', padding: 0 }}
                    >
                        {[
                            { title: 'Real-time Telemetry', desc: 'Live data stream from sensor to cloud.' },
                            { title: 'Smart Alerts', desc: 'Push notifications only when critical.' },
                            { title: 'Historical Charts', desc: 'View growth trends over weeks and months.' }
                        ].map((item, index) => (
                            <li key={index} style={{
                                marginBottom: '2rem',
                                display: 'flex',
                                alignItems: 'flex-start'
                            }}>
                                <div style={{
                                    marginTop: '6px',
                                    width: '6px',
                                    height: '6px',
                                    backgroundColor: 'var(--accent)',
                                    borderRadius: '50%',
                                    marginRight: '1.5rem',
                                    boxShadow: '0 0 10px var(--accent)'
                                }}></div>
                                <div>
                                    <h4 style={{ fontSize: '1.1rem', marginBottom: '0.2rem', fontFamily: 'Manrope, sans-serif', fontWeight: 600 }}>{item.title}</h4>
                                    <p style={{ color: '#666', fontSize: '0.95rem' }}>{item.desc}</p>
                                </div>
                            </li>
                        ))}
                    </motion.ul>
                </div>

                <motion.div
                    style={{ flex: 1, display: 'flex', justifyContent: 'center', minWidth: '300px', y, scale }}
                >
                    <div style={{ position: 'relative' }}>
                        {/* Phone Glow */}
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '80%',
                            height: '80%',
                            background: 'var(--accent)',
                            filter: 'blur(100px)',
                            opacity: 0.1,
                            zIndex: -1
                        }} />

                        <img
                            src={appMockup}
                            alt="Seikaia App Interface"
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                maxHeight: '700px',
                                filter: 'drop-shadow(0 30px 60px rgba(0,0,0,0.5))',
                                transform: 'rotate(-5deg)'
                            }}
                        />
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default AppShowcase;
